import React, { useState } from 'react';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const SingleFileUpload = ({onChnageFile,accept,title}) => {
  const [fileList, setFileList] = useState([]);
  const handleChange = ({ fileList: newFileList }) => {
    if (newFileList.length > 0) {
      setFileList([newFileList[newFileList.length -1]]); 
    } else {
      setFileList([]);
    }
    console.log('Updated fileList:', newFileList);
    onChnageFile( newFileList[newFileList.length -1] )
  };

  // Handle file removal
  const handleRemove = (file) => {
    console.log('Removed file:', file);
    setFileList([]); // Clear the file list when the file is removed
    return true; // Confirm removal
  };

  return (
    <div>
      <Upload
        fileList={fileList}
        multiple={false} 
        onChange={handleChange} 
        onRemove={handleRemove} // Handle file removal
        beforeUpload={() => false} // Prevent automatic upload to server
        accept={accept} // Restrict to .doc and .docx files
      >
        <Button icon={<UploadOutlined />}>{title}</Button>
      </Upload>
    </div>
  );
};

export default SingleFileUpload;